/**
 * @license
 * Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
 */

import '@polymer/iron-iconset-svg/iron-iconset-svg.js';
const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<iron-iconset-svg name="cs-action-24" size="24" style="display: none;">
  <svg>
    <defs>
      <g id="loading">
        <path d="M15,0.393V2.727a9.75,9.75,0,1,1-6,0V0.393A12,12,0,1,0,15,.393Z"></path>
      </g>
      <g id="slide-right-toggle" viewBox="0 0 26.742 27.121">
        <path d="M0 20h7.143v-2.859H0zm0-8.571h15.714V8.571H0zm0-8.572h20V0H0z" fill-rule="evenodd" data-name="Layer 1"></path>
        <path d="M19.172 25.487l1.635 1.634 5.6-5.6a1.154 1.154 0 0 0 0-1.634l-5.6-5.6-1.635 1.634 4.781 4.78zm6.2-4.78"></path>
      </g>
      <g id="slide-left-toggle" viewBox="0 0 26.742 27.121">
        <path d="M26.742 15.927l-1.634-1.634-5.6 5.6a1.154 1.154 0 0 0 0 1.634l5.6 5.6 1.634-1.634-4.78-4.78zm-6.194 4.78"></path>
        <path d="M0 20h7.143v-2.859H0zm0-8.571h15.714V8.571H0zm0-8.572h20V0H0z" fill-rule="evenodd"></path>
      </g>
    </defs>
  </svg>
</iron-iconset-svg>`;

document.head.appendChild($_documentContainer.content);
